<div
  [ngClass]="
    modalConfiguration.header === 'Verify Cell Phone Number'
      ? 'modal-container over-index'
      : 'modal-container'
  "
>
  <div
    class="modal-dialog"
    [style.height.px]="modalConfiguration.height"
    [style.width.px]="modalConfiguration.width"
  >
    <div class="modal-content">
      <div
        class="modal-header d-flex justify-content-between align-items-center"
        *ngIf="modalConfiguration.header"
      >
        <h1
          *ngIf="modalConfiguration.header"
          class="fw-500"
          [innerHtml]="modalConfiguration.header"
        ></h1>
        <img
          src="./assets/icons/close-white.svg"
          alt="Close"
          *ngIf="modalConfiguration.isCloseable"
          (click)="CloseModalWindow()"
          class="close-icon"
        />
      </div>
      <div
        *ngIf="!modalConfiguration.header"
        class="modal-header-no-title d-flex justify-content-end align-items-center"
      >
        <img
          src="./assets/icons/close-filter.svg"
          alt="Close"
          *ngIf="modalConfiguration.isCloseable"
          (click)="CloseModalWindow()"
          class="close-icon"
        />
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
      <div
        [ngClass]="
          modalConfiguration.areButtonsRightAligned ||
          modalConfiguration.includeCancelButton
            ? 'modal-footer d-flex  justify-content-end'
            : 'modal-footer d-flex  justify-content-center'
        "
        *ngIf="
          (modalConfiguration.button1 && modalConfiguration.button2) ||
          modalConfiguration.includeCancelButton
        "
      >
        <ng-container *ngIf="modalConfiguration.button1">
          <button-component
            [buttonClass]="modalConfiguration.button1.buttonClass"
            [Text]="modalConfiguration.button1.text"
            [isLeftImg]="false"
            [isRightImg]="false"
            [isButtonDisabled]="modalConfiguration.button1.disableCallback()"
            (OnClick)="modalConfiguration.button1.callback()"
          ></button-component>
        </ng-container>
        <ng-container *ngIf="modalConfiguration.button2">
          <button-component
            [buttonClass]="modalConfiguration.button2.buttonClass"
            [Text]="modalConfiguration.button2.text"
            [isLeftImg]="false"
            [isRightImg]="false"
            [isButtonDisabled]="modalConfiguration.button2.disableCallback()"
            (OnClick)="modalConfiguration.button2.callback()"
          ></button-component>
        </ng-container>
        <ng-container *ngIf="modalConfiguration.includeCancelButton">
          <button-component
            [buttonClass]="'button button-light ml12'"
            [Text]="modalConfiguration.cancelButtonText"
            [isLeftImg]="false"
            [isRightImg]="false"
            [isButtonDisabled]="false"
            (OnClick)="CloseModalWindow()"
          ></button-component>
        </ng-container>
      </div>
    </div>
  </div>
</div>
